import './AppEnvironmentBanner.scss'

import React, { Component } from 'react'
import cx from 'bem-classnames'

import AdminControls from 'common/views/AdminControls'

import { APP_ENV_PROD } from 'common/constants'
import { toggleBogotaLeaderboardView } from 'common/redux/queue'

class AppEnvironmentBanner extends Component {

  state = {
    adminControls: false,
  }

  componentDidMount() {
    if (_.get(this, 'props.auth.user.feature_flags.hotkeys')) {
      window.document.onkeydown = this.keyHandler
    }
  }

  keyHandler = (e) => {
    if (e.ctrlKey && e.shiftKey && e.keyCode === 79) {
      this.setState({adminControls: true})
    }
  }

  handleControlExit = () => {
    this.setState({adminControls: false})
    window.document.onkeydown = this.keyHandler
  }

  render() {
    const { props } = this
    const { appBanner, dispatch, queue={} } = props

    const appEnv = window.OD.initialState.env
    const showProduction = !!_.get(props, 'auth.user.feature_flags.show_prod_app_env_banner')
    const engOrProduct = !!_.get(props, 'auth.user.feature_flags.engineering_team') || !!_.get(props, 'auth.user.feature_flags.product_team')

    if (appEnv === APP_ENV_PROD && !showProduction) {
      return <div />
    }

    const classes = {
      name: 'AppEnvironmentBanner',
      modifiers: ['production'],
    }
    const classNames = cx(classes, { production: (appEnv === APP_ENV_PROD && showProduction) })
    const showCSRLocationToggle = appBanner && (showProduction || engOrProduct)

    return (
      <div className='AppEnvironmentBannerWrapper'>
        <div className={classNames}>
          <div className="AppEnvironmentBanner__actions">
            { showCSRLocationToggle &&
              <div title="Toggle CSR Location" onClick={() => dispatch(toggleBogotaLeaderboardView())} className="AppEnvironmentBanner__location">
                { queue.showBogotaLeaderboard ? <span>Bogota</span> : <span>Austin</span> }
                <i className="fa fa-globe"/>
              </div>
            }
            { this.state.adminControls &&
              <AdminControls
                handleExit={this.handleControlExit}
                handleEnter={(f) => window.document.onkeydown = f} />
            }
          </div>
          <div>
            <i className="fa fa-cogs" /> { appEnv.toUpperCase() } SERVER</div>
          </div>
      </div>
    )
  }
}

export default AppEnvironmentBanner
